enum AvatarStyleEnum {
  BODY = "body",
  HEAD = "head"
}
export default AvatarStyleEnum;
